import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative pt-20 pb-24 overflow-hidden bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-50 text-brand-700 text-xs font-bold uppercase tracking-wider mb-8">
            <span className="w-2 h-2 rounded-full bg-brand-500 animate-pulse"></span>
            The Football Toolkit
          </div>
          <h1 className="text-5xl md:text-8xl font-black tracking-tighter text-slate-900 mb-8 leading-[0.9]">
            EVERY GOAL. <br/>
            <span className="text-brand-600">IN REAL-TIME.</span>
          </h1>
          <p className="text-lg md:text-xl text-slate-500 mb-10 max-w-xl mx-auto leading-relaxed">
            Create beautiful, live football components for your project. From local leagues to the Champions League, build the experience your fans deserve.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/builder"
              className="w-full sm:w-auto px-10 py-5 text-lg font-bold text-white bg-slate-900 hover:bg-brand-600 rounded-full shadow-2xl transition-all hover:-translate-y-1 text-center"
            >
              Start Building
            </Link>
            <button className="w-full sm:w-auto px-10 py-5 text-lg font-bold text-slate-600 hover:text-slate-900 border border-slate-200 rounded-full transition-all">
              View Examples
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;